import React from 'react';
import { ExclamationTriangleIcon, ClockIcon } from '@heroicons/react/24/outline';
import { formatDateTime } from '../utils/datetime';

const SLAAlerts = ({ alerts }) => {
  if (!alerts || alerts.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center">
          <ExclamationTriangleIcon className="w-5 h-5 mr-2 text-yellow-500" />
          Alertas de SLA
        </h3>
        <p className="text-green-600">Nenhum alerta no momento!</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center">
        <ExclamationTriangleIcon className="w-5 h-5 mr-2 text-red-500" />
        Alertas de SLA ({alerts.length})
      </h3>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {alerts.map((alert, index) => (
          <div
            key={index}
            className={`p-4 rounded-lg border-l-4 ${
              alert.alert_type === 'pending'
                ? 'bg-red-50 border-red-500'
                : 'bg-yellow-50 border-yellow-500'
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center">
                  <ClockIcon className="w-4 h-4 mr-2 text-gray-600" />
                  <a
                    href={`https://lets.omniflex.com.br/app/accounts/${alert.account_id || 1}/conversations/${alert.display_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    Conversa #{alert.display_id}
                  </a>
                  {alert.account_name && (
                    <span className="ml-2 rounded bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
                      {alert.account_name}
                    </span>
                  )}
                </div>

                <div className="mt-2 text-sm text-gray-600">
                  <p>Canal: <span className="font-medium">{alert.inbox_name}</span></p>
                  {alert.agent_name && (
                    <p>Agente: <span className="font-medium">{alert.agent_name}</span></p>
                  )}
                  {alert.team_name && (
                    <p>Time: <span className="font-medium">{alert.team_name}</span></p>
                  )}
                  <p>Tempo de espera: <span className="font-bold text-red-600">
                    {alert.wait_time_minutes} minutos
                  </span></p>
                  <p className="text-xs text-gray-500 mt-1">
                    Criada em: {formatDateTime(alert.created_at)}
                  </p>
                </div>
              </div>

              <span className={`px-2 py-1 text-xs font-semibold rounded ${
                alert.alert_type === 'pending'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {alert.alert_type === 'pending' ? 'Não respondida' : 'Atrasada'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SLAAlerts;
